<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<header>
<h1 class="topictitle1" id="ch9"><a href="#/nav#nch9"><span class="section_number">CHAPTER 4</span><br/><span class="title">SURVIVING THE STING</span></a></h1>
</header>
<p>“He’s drowning!” said a shaky voice some distance from the vat of excrement. It belonged to Terraclon, a twig of a boy, who
            squeezed through the circle of Anand’s abusers. Terraclon was held in almost as much contempt as Anand, and his presence repulsed
            the others.
         </p>
<p>Terraclon thrust his arms, as thin as threads, into the vat. Using all his strength, he managed to pull Anand out, but he
            also sent the vat tumbling, something sure to set off the foreman (even more than the attempted murder of the Roach Boy).
            Anand coughed and flopped in the spreading filth. The other boys scurried back to work just as their fathers noticed the commotion.
         </p>
<p class="txtb2"> </p>
<p>Yormu felt stabbed to see what had happened to his son. How many times had they thrown him in a vat this month? Yormu was
            running towards his boy when Keel grabbed his arm.
         </p>
<p>“Don’t run to him, Yormu. He makes his messes. Let him clean it up.”</p>
<p>Yormu clenched his fists with rage. If only he could speak his mind! He wished for a tongue so long and sharp it could lop
            off Keel’s head. He saw Keel glance at his fists.
         </p>
<p>“Are those fists for me, Yormu? Take a swing and I’ll knock out what few teeth you have left. Get back to work.”</p>
<p>Yormu panted as he strained to keep himself from leaping onto his foreman to climb his chest and rip his ears off. He shook
            his head, defiant.
         </p>
<p>“I said get back to work!” Keel bellowed.</p>
<p>Yormu shook his head again, waiting for the moment Anand could rise and walk. Keel was coming towards him, fist cocked.</p>
<p>“Stop!” shouted Terraclon, yanking Anand to his feet. “He’s up. Look.” Terraclon held Anand’s wobbling body up as he coughed.</p>
<p>“Go back to work, Dad,” Anand choked out. “I’m fine.”</p>
<p>Keel glared at them all before pushing Yormu back to his tasks.</p>
<p class="txtb2"> </p>
<p>After Anand and Terraclon refilled the vat, they removed their muck with several baths in nutshell tubs. As Anand sank under
            the last dome of water, he imagined the time he could leave Cajoria and return in the trappings of the richest trader. He
            would go to the Cajorites’ priests to purchase Keel, Tal, and his other tormentors. Afterwards, he would sell them to an enemy
            nation where, for the rest of their lives, gawkers would pelt them with trash in pits at public showings.
         </p>
<p><i>Dreams beyond dreams, </i>he thought as he continued to wash.
         </p>
<p>As they bathed, the caste’s idols keeper stood nearby repeating the names of the Slopeish gods as he rubbed his generous belly
            stained from the dye of his yellow sash. When the boys were dried, he handed them oily cloths soaked with leaf-cutter <i>kin-scent</i> and muttered a prayer to Goddess Ant Queen. The boys were coating themselves when they heard a hubbub among the middenites.
            All had left their work to gather and stare at the top of the mound. Banners were hanging from the rain shield’s edges.
         </p>
<p>“Look, Anand,” said Terraclon. “Yellow banners! The queen is giving birth again. You know what it means if it’s a girl who
            lives.”
         </p>
<p>“Fission,” said Anand. “A new princess may mean a new colony.”</p>
<p>Terraclon shuddered. “Don’t say it out loud, Anand!”</p>
<p>“Why not? Fission would be a good thing.”</p>
<p>“Fission is never good. It tears families apart.” Looking at Anand, he added, “And friends. Tears them apart, too.”</p>
<p>“The people of this mound are starving. It’s better they divide than die.”</p>
<p>A northern breeze sent dead leaves and dust whirling over the boys. Anand sniffed the air and savored the strange scents of
            some distant land. He had no fear of being forced to a new colony for a few more months. As the most miserable boy in the
            most miserable caste, any change was welcome.
         </p>
<p class="txtb2"> </p>
<p>Queen Polexima was used to giving birth to triplets and quadruplets. It was more difficult with this single infant, whose
            enormous head was crowning.
         </p>
<p>“Push, Your Majesty,” said the midwife as the mound’s high priest, His Most Pious Dolgeeno, arrived with his entourage. Through
            all her pain, the queen almost smiled in contempt. She could see it had taken the priests a good part of the day to dress
            for the royal delivery. Their pollen-powdered faces of yellow contrasted with cassocks of deepest purple and as hats, it appeared
            they had agreed on fuzz cones over the usual skullcaps. Each wore twenty-eight head-to-floor necklaces of moonstones that
            rattled across the tiles as they teetered in on the cube-shaped shoes that gave them height.
         </p>
<p>A man of fifty-three summers, Dolgeeno had small eyes lost in a heavy face. He had three, sometimes four chins. He looked
            to the heavens, then led the other priests in a slow and cumbersome chant circle around Polexima’s bed that drowned out her
            screams as the baby broke through. The midwife gasped.
         </p>
<p>“Show it to me,” said Polexima.</p>
<p>The midwife hesitated before picking up the infant and turning her to the sight of the others.</p>
<p>“Good gods,” said Polexima, “a girl!”</p>
<p>The queen could not hold back tears. Flooded with emotion, she had not realized her legs were apart when Dolgeeno glanced
            between them. She knew he had done so only for the pleasure of humiliating her. Her hatred for him flared as he approached
            with his knife, crafted from the tip of an ancient ant queen’s mandible. He severed the umbilical cord, held the infant upside
            down, and slapped her buttocks to make her cry.
         </p>
<p>Polexima saw that the infant was large and strong and perhaps could survive the poison. <i>Please, Grasshopper, let her live,</i> she prayed to the god of riches and mercy. The infant was freed of her placenta as the jaw of a patrolling sentry ant broke
            through the greased flap of the chamber’s window. Alerted by the newborn’s odor, its antenna slid through the window in search
            of an intruder it would have to kill.
         </p>
<p>“Hurry, please!” the queen said.</p>
<p>“That sentry is too large to break through,” said Dolgeeno.</p>
<p>“But she’s spraying <i>alarm-recruit</i> scent,” Polexima shouted back. “Smaller ones will get through.”
         </p>
<p>“My good queen, I have never lost a baby to sentry ants,” said His Most Pious, even as he was immersing the infant in a basin.
            Once the baby was doused in kin-scent, he raised her and the ant moved on. Dolgeeno nodded towards something buzzing in the
            corner.
         </p>
<p>Strapped into a twig frame, a living mud dauber wasp was lifted onto the shoulders of the priests and brought to Dolgeeno.
            He held up the baby and pressed her buttocks to the wasp’s stinger, already glistening with poison.
         </p>
<p>Polexima had previously witnessed this ritual eighteen times. Seventeen times she had seen daughters die. The newborn would
            expire in a moment or live to wail in agony. The wasp fluttered its clipped wings as its stinger pumped its toxins. Dolgeeno
            pulled the infant away. She made tiny fists and squirmed.
         </p>
<p>Polexima’s heart sank as she watched the infant shiver, then grow still.</p>
<p>“No, she’s . . . ”</p>
<p>Suddenly, blood rushed to the girl’s face and turned it a deep pink. Her little body spasmed and she shrieked.</p>
<p>This daughter would live.</p>
<p>“Thank you, Lord Grasshopper!” said the queen, collapsing into her sheets.</p>
<p>“The gods have found this baby worthy. She shall be called Pareesha,” said Dolgeeno, naming her after the south wind goddess.</p>
<p>One of Dolgeeno’s men handed him a bladder of aphid milk. He smeared a bit of the sticky syrup onto the newborn’s lips.</p>
<p>“May the days of Princess Pareesha be sweet and may her descendants be numerous,” sang the priest. When the infant stopped
            crying, she was set in an amber rocking crib.
         </p>
<p>Polexima drifted into a shallow slumber as she waited for her family’s visit. She knew one of them would be most unhappy,
            a thought that somehow made her smile as she closed her eyes.
         </p>
<p class="txtb2"> </p>
<p>Making their way through the palace’s tunnels were the new baby’s sister, the Crown Princess Trellana, and her father, the
            Warrior King Sahdrin. They sat together on a couch set over the thorax of a carrying ant. Behind them, on their own ants,
            were twenty of Trellana’s twenty-one brothers, most of whom were twins or triplets. They laughed and sang as they sucked from
            bladders of honey liquor. Trellana found them loud and irritating and it deepened her usual pout. She had been summoned prematurely
            from a day with a hairdresser who had fresh gossip from the neighboring mounds. What unsettled her most was pondering that
            this new sibling was her first surviving sister, a teensy thing that would be adored and spoiled by all.
         </p>
<p>Accompanying the procession were hundreds of tiny grooming ants that clustered about the princess as Trellana mixed her perfume
            with <i>queen-scent,</i> the potion that sparked grooming behavior. The little groomers crawled on her trains and her towering but unfinished coiffure
            with their mouths opened to offer their regurgitation. Trellana brushed one away from her eye with more violence than usual
            to see the king staring sideways with his good eye.
         </p>
<p>“Are you well today, my pretty?” Sahdrin asked.</p>
<p>“Certainly I am, Father.”</p>
<p>“You do not seem excited at the prospect of having a sister.”</p>
<p>“Well, yes, of course I am excited,” she said with all the enthusiasm of a corpse. “But I am not excited at the idea that
            I might have to leave you within a year.”
         </p>
<p>When they reached the portal to the queen’s chambers, Sahdrin’s servants helped him down from the ant and plucked off his
            false legs. Trellana began her entry, slowed by her ten-layered costume. Once inside, servants straightened her trains as
            she fanned herself with the clipping of an eye moth’s wing. She waited for the commoners to draw away before floating to the
            crib. Peeking over her fan, she stared silently at the infant’s face as the king, refitted with his legs, swung towards his
            wife on crutches carved from cricket femurs. He set his hand on her arm.
         </p>
<p>“Was it a painful birth, Polly?”</p>
<p>“The most painful since Trellana,” said the queen. “But I have the comfort of knowing it shall be my last.”</p>
<p>The king swung himself toward the crib to join Trellana and look at the second female heir. “Congratulations, Mother,” Trellana
            finally said without making eye contact. “You have done very well.”
         </p>
<p>“Thank you, Trelly. Her arrival will make us a little less sad when you leave,” said Polexima, but rather flatly.</p>
<p>“She shall be very pretty,” Trellana said, pursing her small lips, glossy with green paint.</p>
<p>“If she becomes even half the beauty you are, she will be very lucky indeed,” said Sahdrin.</p>
<p>“Indeed,” said Polexima through a sigh, betraying her disagreement with her husband about her oldest daughter’s appearance.
            “That’s . . . that’s a rather ambitious coiffure,” said the queen as she looked up at her daughter’s jewel-embedded tower
            of hair.
         </p>
<p>“It’s what they are wearing at the Kulfi and Goojinet Mounds,” Trellana said, continuing to stare at the baby.</p>
<p>“I always have a learned orator in my chambers when I get my hair done,” ventured Polexima. “Perhaps you should be learning
            more about our history now, of the kinds of difficulties you and your pioneers might encounter.”
         </p>
<p>“Oh, how tedious, Mother. We have plenty of people to address any complications.”</p>
<p>“It’s not tedious. As you get older, you’ll realize there are advantages to cultivating yourself. You should be learning our
            poetry and sagas, our—”
         </p>
<p>“But I’m not old, Mother,” Trellana snapped. “You are. I should like to enjoy my youth before cramming my head with the words
            of your ‘learned’ blatherers.”
         </p>
<p>Polexima sighed again as Trellana frowned and fixated on a crack in her fingernail. The princes entered the room, drunk and
            noisy, and their sloppy entrance allowed the unwanted grooming ants in. Some of these ants surrounded the crib and frightened
            Pareesha with their offers of vomit. A servant swatted the groomers away, then brought the baby to the shushing queen, who
            saw the newborn was rooting for milk. As Polexima nursed, she broke into a folk tune from her native mound of Palzhad.
         </p>
<div class="song_group">
<p class="song_line">Little one, life is short,</p>
<p class="song_line">But very long on sorrow.</p>
<p class="song_line">Make the most of every day</p>
<p class="song_line">And don’t live for tomorrow.</p>
</div>
<p>The servants smiled at the song, especially as it used words from their caste dialect. Trellana, her brothers, and the king
            did not understand the lyrics, though, and looked annoyed by the queen’s singing. The priests did little to hide their distaste
            before Pious Dolgeeno interrupted.
         </p>
<p>“If Her Highness will excuse me,” he said, before turning to his men. “Priests, the Princess Pareesha has survived the sting.
            We must descend to the cathedral and consult with the gods to tell us when Princess Trellana’s Fission trek should depart.”
         </p>
<p>“Before you do,” said Polexima. “I should like to speak with the scouting party about the new site.”</p>
<p>“Why?” asked Dolgeeno. “The site was determined and approved nearly a year ago.”</p>
<p>“Who approved it? Not me. I will not send my daughter and thousands of our people into the wilderness without some assurance
            of their safety. I should like to speak with the scouting party before you leave for the cathedral.”
         </p>
<p>“As you wish, Majesty,” said Dolgeeno, sending his quickest novitiate as a messenger.</p>
<p>Trellana trembled. She wanted to be a queen but had never wanted to leave Cajoria and found a new colony. She had always been
            told this was her destiny, but the arrival of this infant was turning those words into a reality. She suddenly felt constricted
            by her clothing and unable to breathe. She fainted, and fell softly into the thickness of her own costume, her mouth open.
            Before they were chased away, grooming ants responded to the signal that she was hungry and she came to and realized the ants
            had regurgitated into her opened mouth.
         </p>
<p class="txtb2"> </p>
<p>A short time later, the men who had found and approved the site of the new colony arrived at Polexima’s chambers and stood
            before her and the king and Trellana. Their expedition had begun nine months earlier when the priests’ oracles indicated the
            likely birth of a healthy princess.
         </p>
<p>“The site of the new mound, a meadow surrounded by woods, is north and slightly east of here, a journey of eleven days by
            caravan, or two days on fleet ants, in the uninhabited territory known as Dranveria in the old tongue,” said Pious Estaine,
            the priest of the tree god Bortshu-mox. He wore a twin-winged seedpod as his miter and drew a map with his finger in a dust-box.
         </p>
<p>“Eleven days by caravan? Two days by fleet ant? No Slopeish mound is supposed to be more than one day’s ride from another
            by fleet ant,” said Sahdrin, his voice loud but trembling.
         </p>
<p>“How can I be so far from you, Father?” asked Trellana through whimpers.</p>
<p>Estaine bowed to the king before responding. “Majesty, it is some distance, but the oracles were correct. The new site is
            a meadow surrounded by glorious stands of untouched bortshu trees . . . an ample supply of leaves for twenty generations.”
         </p>
<p>Commander General Batra, the officer whose soldiers had accompanied Estaine, jutted out his box-like chin before speaking.
            Around his chest was a necklace of dried human ears from tree cannibals he had personally killed on the journey. “Pious Estaine
            is correct, Your Majesties. The new site is distant, but treaties with the Seed Eaters prevent us from going east and we risk
            war with the Carpenter tribe if we venture west.”
         </p>
<p>“What is the terrain like?” Polexima asked.</p>
<p>“It is still an extension of the Slope, so not prone to flooding, but with reddish sand,” Estaine answered.</p>
<p>Polexima flinched when she heard “reddish sand,” unsure of why it disturbed her.</p>
<p>“And it is not occupied?” she asked.</p>
<p>“Not by ant peoples. The tree canopies are full of cannibal tribes, but they are primitives who pose little threat.”</p>
<p>“Why have we not colonized it before?”</p>
<p>“Our journey was not without incident,” said Commander Batra. “In the old tongue, the name Dranveria means ‘domain of lair
            spiders,’ of which there are many. Some in our party succumbed to them. Others were carried off by . . . night wasps.”
         </p>
<p>At the mention of night wasps, a long silence chilled the room. Sahdrin sighed through his nostrils. “Very well,” he said.</p>
<p>“I don’t know that it is very well at all,” said Polexima, searching her memories.</p>
<p>“Fission has happened hundreds of times in the history of the Slopeish peoples and in conditions just like these,” said Dolgeeno.
            “Nearly always it is peaceful and successful. Princess Trellana will be protected by Commander General Batra’s army, as well
            as by me, my priests, and all our magic.”
         </p>
<p>Polexima’s eyes shifted as a rush of images filled her head. “One remembers old stories about a previous attempt to colonize
            the land of red sand,” she said, “and of the mysterious and brutal . . . Dranverites.”
         </p>
<p>“Stories? What stories?” Trellana asked. She shot her mother a piercing look, then turned to Dolgeeno.</p>
<p>“In one legend,” said the queen, “the dried bones and bloody clothing of Kulfish pioneers were returned to their original
            mound in neat, cube-shaped piles.”
         </p>
<p>With slit eyes, Dolgeeno turned to Estaine and Batra.</p>
<p>“Pious Estaine, did you see even one little <i>Dranverite </i>on your expedition?” he asked, as if he were speaking to a child. “How about you, General?” he sang with a smug smile. “Anyone
            mounted on a . . . <i>red</i> hunter ant?”
         </p>
<p>“Of course not,” said General Batra. “I give my word as a soldier.”</p>
<p>“By all the gods, no!” swore Estaine in agreement with the general. Polexima watched as both men blinked at each other, then
            looked away in haste.
         </p>
<p>“People tell lots of silly stories for the fun of being scared,” said His Most Pious, turning to Trellana. “Fear not, Princess.
            The omens for your new mound are exceptionally good. There are no such beings as Dranverites and certainly no one to challenge
            Slopeish supremacy.”
         </p>
<p>Trellana and Sahdrin sighed with relief, but Polexima was still not sure. She searched the faces of the men for signs that
            they had lied. She did not sense an out-and-out deception, but she was sure of an unease between them.
         </p>
<p>“I overheard a conversation,” Polexima said, “whispered between my servants, in their own tongue.” The queen began to whisper
            herself. “They said the laborers that accompanied your expedition were not killed by insect and spider predators, but by our
            own Cajorite soldiers.”
         </p>
<p>“Ridiculous,” said Dolgeeno with a roll of his eyes. “Soldiers have no right to kill your subjects without cause—they would
            risk their own execution.”
         </p>
<p>“Perhaps these laborers saw something,” said the Queen, “something you did not wish them to report to the mound.”</p>
<p>“Like what, dear Queen?” Dolgeeno asked impatiently, his words worked into a melody.</p>
<p>“The border walls of another nation which they were ordered to clear . . . as their last act before dying.”</p>
<p>“Polexima, really,” said the high priest as he shook his head and sent ripples through his wattles. “What calamitous shape
            we would be in if we believed the stories of the simple folk.” He turned to Batra and Estaine. “Again, under oath to Mantis,
            did either of you see red ants or anyone riding on one?”
         </p>
<p>“Certainly not,” said Estaine.</p>
<p>“By Mantis, no,” said Batra.</p>
<p>“Then you are dismissed,” said the high priest, cutting short the meeting. “If Your Majesties will excuse me, we must prepare
            for our divine audience.”
         </p>
<p>Polexima watched Dolgeeno’s weighty buttocks jiggle under his robes as he exited the room.</p>
<p><i>How I loathe that man.</i></p>
<p class="txtb2"> </p>
<p>After changing into their evening robes, Dolgeeno led the priest of each of the Slopeites’ gods on an ant train down the spiral
            path to the cathedral deep inside the mound. Since he had left the queen’s chamber, he had been preoccupied with Polexima,
            once again irked by her endless and unwomanly curiosity. <i>Perhaps this new daughter will turn her away from affairs of state and back to motherhood, </i>he thought.
         </p>
<p>“Stop thinking about her,” said his seat mate, Pious Estaine, who was sure of why the high priest silently frowned in the
            soft light of their torch topped with a lightning-fly egg. “You can’t change her and you can’t kill her.”
         </p>
<p>“Are you so sure about that?” Dolgeeno asked, smiling ever so slightly.</p>
<p>Estaine feigned a gasp and slapped his chest. “Why, Pious, unless you include me in this plot I could have you stripped of
            scent for treason.”
         </p>
<p>“Perhaps then you might finally succeed me as our mound’s high priest.”</p>
<p>The two chuckled as they patted each other’s thighs.</p>
<p>“Here’s something that will help you forget Polexima the Palzhanite,” said Estaine. He handed Dolgeeno his consecrated wafer
            of the Holy Mildew, the precious fungus the priests scraped from the ceilings of the mushroom chambers. The two chewed their
            black, bitter wafers and the effects were almost instantaneous once it was washed down with a slug of honeysuckle liquor.
            Once inside the sanctuary, gorgeously lit by a thousand torches, the priests paced in a chant circle before a gaudy altar
            with their hundred idols. Their feet disappeared and they floated in a joyous trance. Soon, the walls would melt and the idols
            would transform into the real gods—gods who would make pronouncements and answer the questions of mortals.
         </p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter_4.vue?76ea1718